var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSustainable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "56px",
    viewBox: "0 0 48 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sustainably Sourced Materials") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47,31.3384221 C47,44.0409713 36.7025492,54.3384221 24,54.3384221 C11.2974508,54.3384221 1,44.0409713 1,31.3384221 L1,31.3384221 Z M23.5,8.5 L24,48.5 M21.6467135,10.0978155 L23.3489034,12.3566979 M23.5,1.21233728 C27.9495169,6.16845185 30.0558558,9.77319482 29.819017,12.0265662 C29.4637587,15.4066233 26.4356872,17.8587072 23.0556301,17.5034489 C19.6755731,17.1481906 17.2234892,14.1201191 17.5787475,10.740062 C17.8155864,8.48669066 19.7893372,5.3107824 23.5,1.21233728 Z",
    id: "Sustainably-Sourced-Materials",
    stroke: "#000000",
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustainable);
export default __webpack_public_path__ + "static/media/sustainable.ef592e14bfcb554329dbcdedf0d9fcd9.svg";
export { ForwardRef as ReactComponent };